import { render } from "./BusDetails.vue?vue&type=template&id=765b7c2e&scoped=true"
import script from "./BusDetails.vue?vue&type=script&lang=js"
export * from "./BusDetails.vue?vue&type=script&lang=js"

import "./BusDetails.vue?vue&type=style&index=0&id=765b7c2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765b7c2e"]])

export default __exports__